import { WebEvents } from "@web/src/events/web-events";

const SESSION_KEY = "setlist_silent_mode_toast_shown";

const isMobileDevice =
  typeof navigator !== "undefined" &&
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export function showSilentModeToastOnce(): void {
  if (!isMobileDevice) return;
  if (sessionStorage.getItem(SESSION_KEY)) return;
  sessionStorage.setItem(SESSION_KEY, "1");
  WebEvents.emit("SHOW_TOAST", {
    title: "Silent Mode",
    description:
      "Turn off Silent Mode on your device to hear the metronome and drone pads.",
    variant: "warning",
  });
}
